<div class="container-fluid">
    <!-- Header Bar -->
    <div class="re-header-bar mb-4">


        <div class="container-fluid">
            <div class="row align-items-center">

                <!-- LEFT: Sort By -->
                <div class="col-md-3 col-12 mb-2 mb-md-0">
                    <div class="d-flex align-items-center">
                        <label for="sort-select" class="sort-label me-2 mb-0">Sort By:</label>
                        <select id="sort-select" class="form-select form-select-sm w-auto" (change)="applyFilters()">
                            <option value="">Select</option>
                            <option value="latest">Latest</option>
                            <option value="priceLow">Price: Low to High</option>
                            <option value="priceHigh">Price: High to Low</option>
                        </select>
                    </div>
                </div>

                <!-- RIGHT: Search + Filter + Add Property -->
                <div class="col-md-9 col-12 d-flex justify-content-end flex-wrap gap-2">

                    <!-- Search Bar -->
                    <div class="re-search d-flex align-items-center flex-grow-1" style="max-width: 600px;">
                        <span class="search-icon"><i class="bi bi-geo-alt"></i></span>
                        <input type="text" class="search-input flex-grow-1" placeholder="Enter city, Locality, Project">
                        <button class="search-btn d-flex align-items-center"><i class="bi bi-search me-1"></i>
                            Search</button>
                    </div>

                    <!-- Filter Button -->
                    <button class="btn re-filter-btn d-flex align-items-center justify-content-center"
                        data-bs-toggle="offcanvas" data-bs-target="#filterOffcanvas">
                        <img src="assets\Real-Estate\icons\filter.png" alt="Filter" class="filter-icon">
                    </button>


                    <!-- Add Property Button -->
                    <!-- <button class="re-add-btn">+ Add Property</button> -->

                </div>

            </div>
        </div>

    </div>




    <!-- Property Grid -->
    <div class="re-property-grid" id="propertyGrid">
        <!-- Card View -->


        <div class="prop-section">
            <div class="row g-3">

                <div class="col-lg-6 col-md-6 col-12" *ngFor="let property of filteredProperties; let i = index">

                    <div class="prop-card d-flex">

                        <!-- Left Image Column -->
                        <div class="prop-img-col p-1 d-flex align-items-center justify-content-center">
                            <div class="prop-img-wrapper w-100 h-100 position-relative rounded overflow-hidden">
                                <img [src]=" property.listingImage ? property.listingImage : 'assets/Real-Estate/Illustrations/NoImageFound.jpg'"
                                    class="prop-img w-100 h-100 rounded" alt="{{ property.title }}">

                                <span *ngIf="property.isVerified"
                                    class="prop-verified-img position-absolute top-0 end-0 m-2 d-flex align-items-center justify-content-center">
                                    <img src="assets\Real-Estate\icons\g_verified.png" alt="Verified"
                                        class="verified-icon">
                                </span>

                            </div>
                        </div>


                        <!-- Right Content Column -->
                        <div class="prop-content flex-grow-1">

                            <!-- Title + Location + Actions -->
                            <div class="d-flex justify-content-between align-items-start">

                                <!-- Left: Title & Location -->
                                <div class="prop-info">
                                    <h5 class="prop-title two-line mb-1"
                                        [routerLink]="['/home/listing', property.propertyId]" style="cursor: pointer;">
                                        {{ property.title }}</h5>
                                    <p class="prop-location mb-0"><i class="bi bi-geo-alt"></i> {{
                                        property.locality }}, {{ property.city }}, {{
                                        property.state }}, {{ property.pincode }}
                                    </p>
                                </div>

                                <!-- Right: Action Buttons -->
                                <div class="prop-actions d-flex gap-2">
                                    <!-- Favorite Button -->
                                    <button class="prop-icon-btn">
                                        <span class="custom-icon-square" (click)="toggleShortlist(property.propertyId)">
                                            <img [src]="checkForShortlist(property.propertyId) ? 'assets/Real-Estate/icons/shortlisted.png' : 'assets/Real-Estate/icons/shortlist.png'"
                                                alt="Favorite" class="custom-icon">
                                        </span>
                                    </button>

                                    <!-- Report Button -->
                                    <button class="prop-icon-btn">
                                        <span class="custom-icon-square"
                                            (click)="openReportListingModal(property.propertyId)">
                                            <img src="assets\Real-Estate\icons\Flag.png" alt="Report"
                                                class="custom-icon">
                                        </span>
                                    </button>
                                </div>


                            </div>


                            <hr class="prop-separator" />

                            <!-- Price & EMI -->
                            <div class="d-flex justify-content-between align-items-center">
                                <!-- Show Price -->
                                <p class="prop-price">₹ {{ property.price| number }}</p>

                                <!-- Conditionally Show EMI or Deposit -->
                                <small class="prop-emi" *ngIf="property.listingType === 'Sale'">
                                    <strong> ₹{{ calculateEMI(property.price) | number }}/Month </strong><br>
                                    Estimated EMI
                                </small>

                                <small class="prop-emi" *ngIf="property.listingType === 'Rent'">
                                    <strong> ₹{{ property.depositAmount || (property.price * 3) |
                                        number }} </strong><br>
                                    Security Deposit
                                </small>
                            </div>


                            <!-- Details Row -->
                            <div class="prop-details d-flex flex-wrap gap-4 mt-2">
                                <span>
                                    <img src="assets/Real-Estate/icons/superarea.png" class="details-icon" alt="Area">
                                    {{ property.superArea }}
                                    sqft
                                </span>
                                <span>
                                    <img src="assets/Real-Estate/icons/bathroom.png" class="details-icon"
                                        alt="Bathroom"> {{
                                    2 }}
                                    Bathrooms
                                </span>
                                <span>
                                    <img src="assets\Real-Estate\icons\bedroom.png" class="details-icon" alt="BHK"> {{
                                    property.bhk}} BHK
                                </span>
                                <span>
                                    <img src=" assets\Real-Estate\icons\facing.png" class="details-icon" alt="BHK"> {{
                                    property.facing
                                    }}
                                </span>
                            </div>
                            <!-- POSTEDBY -->
                            <!-- <div class="prop-poster d-flex justify-content-between align-items-center mt-2">
                <div class="d-flex align-items-center gap-2 poster-text">
                  <img src="assets\images\RealEstate\owner.png" alt="User" class="poster-icon">
                  <span><strong>Posted By:</strong> {{ property.postedBy }}</span>
                </div>
              </div> -->

                            <!-- Info Icon with Hover Tooltip -->
                            <!-- <div class="prop-postedby">
                                
                                <span class="info-icon">i</span>
                                <span class="postedby-tooltip"> <i class="bi bi-person-circle me-1"></i>Posted By: Mihir Jadhav</span>
                            </div> -->

                        </div>

                    </div>

                </div>
            </div>

            <div #scrollAnchor class="scroll-anchor"></div>

            <!-- Loader (While Fetching More Data) -->
            <div class="loader-section text-center py-4" *ngIf="isListingLoading">
                <div class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <p class="mt-2 text-muted">Loading more properties...</p>
            </div>

            <!-- End of Listing Message -->
            <div class="end-message text-center py-4"
                *ngIf="!hasMore && !isListingLoading && filteredProperties.length > 0">
                <hr class="w-25 mx-auto mb-3 opacity-50" />
                <p class="text-muted mb-0">You’ve reached the end of the listings</p>
            </div>


            <!-- No Property Found -->
            <div class="text-center py-5" *ngIf="!isListingLoading && filteredProperties.length === 0">
                <p class="text-muted fs-5">No properties found.</p>
            </div>

            <!-- No Listings Found Message -->
            <div class="col-12" *ngIf="filteredProperties.length === 0">
                <div class="text-center py-5">
                    <i class="bi bi-house-door display-1 text-muted mb-3"></i>
                    <h5 class="text-muted mb-2">No such listing found</h5>
                    <p class="text-muted">Try adjusting your filters or search criteria</p>
                </div>
            </div>


        </div>

        <!-- Offcanvas Filter Sidebar -->
        <div class="offcanvas offcanvas-end p-3 custom-offcanvas " tabindex="-1" id="filterOffcanvas"
            aria-labelledby="filterOffcanvasLabel">
            <div class="offcanvas-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0 re-title-not" id="filterOffcanvasLabel">Filters</h5>
                <button type="button" class="border-0 bg-transparent text-dark" data-bs-dismiss="offcanvas"
                    aria-label="Close">
                    <i class="fas fa-times" style="color: #011044; font-size: 25px;"></i>
                </button>
            </div>

            <div class="offcanvas-body">
                <div class="range-slider-wrapper">
                    <label class="form-label fw-bold">
                        Price Range: ₹{{ minPrice }} Lacs to ₹{{ maxPrice }} Cr
                    </label>

                    <div class="slider-container">
                        <input type="range" class="range-thumb" [min]="minValue" [max]="maxValue" [step]="step"
                            [(ngModel)]="minPrice" (input)="updateTrack()" />
                        <input type="range" class="range-thumb" [min]="minValue" [max]="maxValue" [step]="step"
                            [(ngModel)]="maxPrice" (input)="updateTrack()" />
                        <div class="range-track">
                            <div class="range-fill" [ngStyle]="{ left: leftPercent + '%', width: fillWidth + '%' }">
                            </div>
                        </div>
                    </div>
                </div>



                <!-- Build-up Area -->
                <div class="range-slider-wrapper">
                    <label class="form-label fw-bold">
                        Build-Up Area: {{ minArea }} sqft to {{ maxArea }} sqft
                    </label>

                    <div class="slider-container">
                        <!-- Min Range -->
                        <input type="range" class="range-thumb" [min]="minAreaValue" [max]="maxAreaValue"
                            [step]="areaStep" [(ngModel)]="minArea" (input)="updateAreaTrack()" />

                        <!-- Max Range -->
                        <input type="range" class="range-thumb" [min]="minAreaValue" [max]="maxAreaValue"
                            [step]="areaStep" [(ngModel)]="maxArea" (input)="updateAreaTrack()" />

                        <!-- Track -->
                        <div class="range-track">
                            <div class="range-fill"
                                [ngStyle]="{ left: areaLeftPercent + '%', width: areaFillWidth + '%' }"></div>
                        </div>
                    </div>
                </div>


                <!-- BHK Type -->
                <label class="form-label fw-bold">BHK Type</label>
                <div class="d-flex flex-wrap gap-2 mb-3">
                    <button class="custom-filter-btn" *ngFor="let bhk of bhkTypes"
                        [ngClass]="{ 'active': selectedBHK === bhk }" (click)="selectBHK(bhk)">
                        {{ bhk }}
                    </button>

                </div>

                <!-- Possession Status -->
                <label class="form-label fw-bold">Possession Status</label>
                <div class="d-flex flex-wrap gap-2 mb-3">
                    <button class="custom-filter-btn" *ngFor="let status of possessionStatuses"
                        [ngClass]="{ 'active': selectedPossession === status }" (click)="selectPossession(status)">
                        {{ status }}
                    </button>
                </div>


                <!-- Posted Since -->
                <label class="form-label fw-bold">Posted Since</label>
                <div class="d-flex flex-wrap gap-2 mb-3">
                    <button class="custom-filter-btn" *ngFor="let period of postedSinceOptions"
                        [ngClass]="{ 'active': selectedPostedSince === period }" (click)="selectPostedSince(period)">
                        {{ period }}
                    </button>
                </div>


                <!-- Property Age -->
                <label class="form-label fw-bold">Property Age (In Years)</label>
                <div class="d-flex flex-wrap gap-2 mb-3">
                    <button class="custom-filter-btn" *ngFor="let age of propertyAgeOptions"
                        [ngClass]="{ 'active': selectedPropertyAge === age }" (click)="selectPropertyAge(age)">
                        {{ age }}
                    </button>
                </div>

                <!-- Bathroom -->
                <label class="form-label fw-bold">Bathroom</label>
                <div class="d-flex flex-wrap gap-2 mb-3 overflow-hidden">
                    <button class="custom-filter-btn" *ngFor="let bath of bathroomOptions"
                        [ngClass]="{ 'active': selectedBathroom === bath }" (click)="selectBathroom(bath)">
                        {{ bath }}
                    </button>
                </div>

                <!-- Floors -->
                <label class="form-label fw-bold">Floors</label>
                <div class="d-flex flex-wrap gap-2 mb-3 overflow-hidden">
                    <button class="custom-filter-btn" *ngFor="let floor of floorOptions"
                        [ngClass]="{ 'active': selectedFloor === floor }" (click)="selectFloor(floor)">
                        {{ floor }}
                    </button>
                </div>

                <!-- Furnishing -->
                <label class="form-label fw-bold">Furnishing</label>
                <div class="d-flex flex-wrap gap-2 mb-3 overflow-hidden">
                    <button class="custom-filter-btn" *ngFor="let furnishing of furnishingOptions"
                        [ngClass]="{ 'active': selectedFurnishing === furnishing }"
                        (click)="selectFurnishing(furnishing)">
                        {{ furnishing }}
                    </button>
                </div>

                <!-- Action Buttons -->
                <div class="d-flex justify-content-between mt-3">
                    <button class="btn btn-outline-secondary w-50 me-2" (click)="resetFilters()">Reset</button>
                    <button class="btn btn-primary w-50" style="background-color:#011044; border:none;"
                        (click)="applyFilters()">Apply</button>
                </div>




            </div>
        </div>
    </div>